import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import imgPrincipal from './assets/images/imagen_principal.png';

function About() {
  const [activePage, setActivePage] = useState('about'); // Initialize with 'about' as the active page

  function handlePageClick(page) {
    setActivePage(page);
  }

    return (
      <div className="about">
        <div className="about-title">
          <h1>¡Bienvenido!</h1>
        </div>
        <div className="about-text">
          <p>
            Comprender el mundo en el cuál vives no debe ser estresante.
          </p>
        </div>
        <div className="about-body">
          <div className="about-image-container">
            <a target="_blank" rel="noopener" href="https://twitter.com/EconFinTalked/status/1659282253963460609?s=20"><img className="about-image" src={imgPrincipal} alt="About Image" /></a>
          </div>
          
          <div className="about-title-2">
            <h2>¿Qué es EFT?</h2>
          </div>
          
          <div className="about-text-2">
            <p> Te guste la economía o no, todos formamos parte de ella y es el campo de juego de todos en nuestro día a día, 
              por lo cuál resulta de gran beneficio para todos los aspectos de nuestras vidas el comprenderla, para así tomar mejores decisiones. </p>
            <p>¡Todo esto de manera sencilla, amena y libre de tecnicismos, cómo nadie nunca lo ha hecho we!</p>
            <p>¡Cáele a la comunidad la cuál busca hacer la economía algo amigable y provechoso, y así cada quien construir un mejor país!</p>
          </div>
  
          <div className="about-buttons">
          <Link
            to="/reepas"
            className={activePage === 'reepas' ? 'active' : ''}
            onClick={() => handlePageClick('reepas')}>
            <button className="about-button">Yo quiero...</button>
          </Link>

          <Link
            to="/library"
            className={activePage === 'library' ? 'active' : ''}
            onClick={() => handlePageClick('library')}>
            <button className="about-button">Nuestros Hilos Valiosos</button>
            </Link>
          </div>
        </div>
      </div>
    );
}

export default About;